<template>
  <section class="order-container">
    <div class="order-container-item" v-for="refund in orderListData" :key="refund.refundId">
      <refund-item :refund="refund"></refund-item>
    </div>
  </section>
</template>
<script>
import refundItem from './components/refundItem.vue';
export default {
  components: { refundItem },
  data() {
    return {
      orderListData: []
    };
  },
  created() {
    const { orderDetailId, orderId } = this.$route.query;
    this.$fetch
      .getSupplyRefundListByGoods({
        orderDetailId,
        orderId
      })
      .then((res) => {
        this.orderListData = res || [];
      });
  }
};
</script>
<style lang="less" scoped>
.order-container {
  height: 100%;
  background: #f5f5f5;
  padding: 12px;
  .order-container-item {
    margin-bottom: 12px;
  }
}
</style>